import {JSPLaborRollupTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class JSPLaborRollupTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in JSPLaborRollupTypeCd ) {
      this._values.push(JSPLaborRollupTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): JSPLaborRollupTypeCd {

    for ( const obj in JSPLaborRollupTypeCd ) {
      if (JSPLaborRollupTypeCd[obj] === value){
        return JSPLaborRollupTypeCd[obj] as JSPLaborRollupTypeCd;
      }
    }
  }
}

const JSPLaborRollupTypeCdHelper = new JSPLaborRollupTypeCdHelperEnumHelperClass();
export default JSPLaborRollupTypeCdHelper;
